import moment from "moment";
import columns from "../../../../../../react-table/helpers/columns";
import {roundDecimal} from "../../../../../common/redux/selectors/util";
import {sumTotal, totalRowRatio,} from "../../../../../../react-table/helpers/rowTotals";

function determineClassName(value) {
  let className = "";
  if (value === 100) {
    className = "bg-green";
  }
  if (value < 100) {
    className = "bg-red";
  }
  return className;
}

function formatDate(date) {
  return moment(date).format("DD/MM");
}

export function getGetPropsForWeek(week) {
  return (state, rowInfo) => {
    let className = "";
    if (rowInfo) {
      const responded = rowInfo.row[`responseRate${week.number}`];
      className = determineClassName(responded);
    }
    return {
      className,
    };
  };
}

export function getGetPropsForWeeksSummary() {
  return (state, rowInfo) => {
    let className = "";
    if (rowInfo) {
      const responded = roundDecimal(rowInfo.row.responseRate);
      className = determineClassName(responded);
    }
    return {
      className,
    };
  };
}

export function weekColumns(weeks, data) {
  const { NumberColumn } = columns(data);
  return weeks.map((week, index) => {
    const preAdvisedHeader = `Pre advised\nWeek ${week.number}\n${formatDate(week.startDate)} to ${formatDate(week.endDate)}`;
    const respondedHeader = `Responded %\nWeek ${week.number}\n${formatDate(week.startDate)} to ${formatDate(week.endDate)}`;

    return [
      new NumberColumn(
        preAdvisedHeader,
        (row) => row.weeks[index].preAdvised || 0
      )
        .withId(`preAdvised${week.number}`)
        .withMinWidth(121)
        .withTotalHeader(sumTotal)
        .withGetProps(getGetPropsForWeek(week)),
      new NumberColumn("respondedColumn", (row) => row.weeks[index].responded)
        .withId(`responded${week.number}`)
        .withTotalHeader(sumTotal)
        .withMinWidth(121)
        .withShow(false),
      new NumberColumn(respondedHeader, (row) =>
        roundDecimal(row.weeks[index].responseRate || 0)
      )
        .withType("percentageWithoutSign")
        .withMinWidth(121)
        .withId(`responseRate${week.number}`)
        .withTotalHeader(
          totalRowRatio(
            [`responded${week.number}`, `preAdvised${week.number}`],
            false
          )
        )
        .withGetProps(getGetPropsForWeek(week)),
    ];
  });
}

export function summaryColumns(weeks, data) {
  const firstWeek = weeks[0];
  const lastWeek = weeks[weeks.length - 1];

  const { NumberColumn } = columns(data);
  const preAdvisedHeader =
    `Pre advised\nWeek ${firstWeek.number} - ${lastWeek.number}\n${formatDate(firstWeek.startDate)} to ${formatDate(lastWeek.endDate)}`;

  const respondedHeader = `Responded %\nWeek ${firstWeek.number} - ${lastWeek.number}\n${formatDate(firstWeek.startDate)} to ${formatDate(lastWeek.endDate)}`;

  return [
    new NumberColumn(preAdvisedHeader, "summary.preAdvised")
      .withTotalHeader(sumTotal)
      .withMinWidth(121)
      .withGetProps(getGetPropsForWeeksSummary()),
    new NumberColumn(respondedHeader, (row) =>
      roundDecimal(row.summary.responseRate)
    )
      .withType("percentageWithoutSign")
      .withId("responseRate")
      .withTotalHeader(
        totalRowRatio(["summary.responded", "summary.preAdvised"], false)
      )
      .withMinWidth(130)
      .withGetProps(getGetPropsForWeeksSummary()),
    new NumberColumn("Responded", "summary.responded")
      .withMinWidth(121)
      .withShow(false),
  ];
}
